<template>
  <span>
    {{ parsedAmount }}
  </span>
</template>

<script>
export default {
  props: {
    amount: {
      type: Number || String,
      required: true
    },
    decimals: {
      type: Number,
      default: 2
    },
    rounded: {
      type: Boolean,
      default: true
    },
    truncated: {
      type: Boolean,
      default: false
    },
    sign: {
      type: String,
      default: "$"
    },
    separated: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    totalSeparated(total) {
      const tString = total.toString();
      const tSplit = tString.split(".");
      const tInteger = tSplit[0] || "";
      const tDecimals = tSplit[1] || "";
      const tSeparated = tInteger.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      return `${tSeparated} ${tDecimals ? `.${tDecimals}` : ""}`;
    }
  },
  computed: {
    totalRounded() {
      let zeros = "";
      const total = Number(
        Math.round(this.amount + "e" + this.decimals) + "e-" + this.decimals
      );
      try {
        const zeroRepeat = this.decimals - String(total).split(".")[1].length;
        zeros = "0".repeat(zeroRepeat);
      } catch (e) {
        e;
      }
      return total + zeros;
    },
    totalTruncated() {
      return this.amount.toFixed(this.decimals);
    },
    parsedAmount() {
      const { rounded, truncated, separated, sign } = this;
      let total = sign ? sign : "";
      if (rounded) total += this.totalRounded;
      else if (truncated) total += this.totalTruncated;
      else total += this.amount;
      if (separated) total = this.totalSeparated(total);

      return total;
    }
  }
};
</script>

<style></style>
